import { i18n } from '@/plugins'

export const showError = async (
  e,
  toast,
  defaultMessage = i18n.t('message.get_data_failed'),
  returnErrObj = false
) => {
  // reason_code付きのエラーはaxiosインターセプタ(plugins/axios.ts)が
  // err_msg.<reason_code>で日本語化して通知済み。ここでdetail(英文)を出すと
  // 二重通知になるため何もしない。
  if (e?.isToastShown) return

  if (e.response && e.response.data instanceof Blob) {
    const blob = e.response.data // Get the Blob from the error response
    let errorDetails = defaultMessage
    let errorCode = null
    try {
      // If the error message is JSON, parse it
      const errorMessage = await blob.text()
      const errorBody = JSON.parse(errorMessage)
      // blobレスポンスはインターセプタが中身を読めないため、ここで日本語化する。
      if (errorBody.reason_code) {
        errorCode = errorBody.reason_code
        errorDetails = i18n.t(`err_msg.${errorBody.reason_code}`, {
          ...errorBody.params
        })
      } else if (errorBody.detail?.description) {
        errorDetails = errorBody.detail.description
        errorCode = errorBody.detail.code
      }
    } catch (e) {
      console.log(e)
    }
    if (returnErrObj) return {code: errorCode, detail: errorDetails}
    toast.error(errorDetails)
  } else if (e.response?.data?.reason_code) {
    // _noToast付きのリクエストはインターセプタが通知しないため、ここで日本語化する。
    const { reason_code, params } = e.response.data
    toast.error(i18n.t(`err_msg.${reason_code}`, { ...params }))
  } else if (e.response?.data?.detail) {
    const { detail } = e.response.data
    if (detail?.msg) {
      if (detail?.is_auto_close_notification !== undefined && detail.is_auto_close_notification === false) {
        toast.error(detail?.msg, {timeout: false})
      } else {
        toast.error(detail?.msg)
      }
    }
    else if (detail?.error_code) toast.error(i18n.t(`error_code.${detail?.error_code}`))
    else if (detail?.used_in_assignment) toast.error(i18n.t(`used_in_assignment.${detail?.used_in_assignment}`))
    else if (detail?.used_in_ar) toast.error(i18n.t(`used_in_ar.${detail?.used_in_ar}`))
    else if (detail?.used_as_default_vrt) toast.error(i18n.t(`used_as_default_vrt.${detail?.used_as_default_vrt}`))
    else if (detail?.used_as_default_itm) toast.error(i18n.t(`used_as_default_itm.${detail?.used_as_default_itm}`))
    else if (detail?.used_in_master_customer) toast.error(i18n.t(`used_in_master_customer.${detail?.used_in_master_customer}`))
    else if (detail?.description) toast.error(detail?.description)
    else if (typeof detail === 'string') toast.error(i18n.t(`err_msg.${detail}`))
    else toast.error(defaultMessage)
  } else {
    toast.error(defaultMessage)
  }
}

export const scrollTop = () => {
  window.scrollTo(0, 0)
}

export const scrollBottom = () => {
  window.setTimeout(() => {
    window.scrollTo(0, document.body.scrollHeight)
  }, 300)
}
